import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import '../css/sidebar.css';

import placeholder from "../images/default-blog.jpg";

const Sidebar = ({ posts }) => {

  const categoryList = useStaticQuery(graphql`
    {
      allWpCategory {
        nodes {
          id
          wpURI
          name
        }
      }
    }
  `)

  const categories = categoryList.allWpCategory.nodes;

  return (
    <React.Fragment>
      <p className="blogSidebarTitle">Most Recent</p>

      { posts &&
        posts.map(post => {
          const { id, title, link, featuredImage } = post;
          const imageData = getImage(featuredImage?.node?.localFile);

          return (
            <div key={id} className="grid grid-bleed align-center blogGrid">
              <div className="col-sm-4">
                <a href={link}>
                  <div className="sidebarImage">
                    {imageData ? (
                      <GatsbyImage
                        image={imageData}
                        alt={featuredImage.node.altText || title}
                        objectFit="cover"
                        style={{ height: '100%' }}
                      />
                    ) : (
                      <img src={placeholder} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    )}
                  </div>
                </a>
              </div>
              <div className="col-sm-8">
                {/* <p className="bDate">{date}</p> */}
                <a href={link} className="bTitle">{title}</a>
              </div>
            </div>
          )
        })
      }

      <hr className="sidebarDivider" />
      <p className="blogSidebarTitle">Categories</p>
      <br />

      <div className="sidebar-categories">
        
          { categories &&
            categories.map(post => {
              const { id, name, wpURI } = post;
              return (<div key={id} className=""><Link className="catName" to={wpURI}>{name}</Link></div>)
            })
          }
        
      </div>


    </React.Fragment>
  )
}

export default Sidebar